import { RemoteResumeRecurringPushNotification } from 'data/usecases';
import { ResumeRecurringPushNotificationUseCaseInterface } from 'domain/usecases/push-notification/resume-recurring-push-notification';
import { makeApiUrlResumeRecurringPushNotification } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeResumeRecurringPushNotification =
  (): ResumeRecurringPushNotificationUseCaseInterface =>
    new RemoteResumeRecurringPushNotification(
      makeApiUrlResumeRecurringPushNotification(),
      makeAxiosHttpClient(),
    );
